import { Box, CircularProgress } from '@mui/material'
import styled from '@emotion/styled'

export const Container = styled(Box)`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Loading = styled(CircularProgress)`
  color: rgba(40, 56, 151, 0.6);

  .MuiCircularProgress-track {
    color: #1a1c56;
  }
`
